import { Injectable, signal } from '@angular/core';

export type SuperAdminAccessTab = 'account' | 'admin';

/**
 * Holds which "Access" tab (Account Access / Admin Access) the super admin
 * has selected in the home sidebar, so the header nav (a sibling component)
 * can render the matching navigation set.
 */
@Injectable({ providedIn: 'root' })
export class SuperAdminAccessService {
  readonly selectedTab = signal<SuperAdminAccessTab>('account');

  setTab(tab: SuperAdminAccessTab): void {
    this.selectedTab.set(tab);
  }
}
